// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TableHeaderWithIcon_wrapper_38zp5"};